import { useEffect } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import * as DocumentsActions from 'documents-ui/actions/DocumentsActions';
import * as DocumentsSettingActions from 'documents-ui/actions/DocumentsSettingActions';
import * as DocumentsSummaryActions from 'documents-ui/actions/DocumentsSummaryActions';
import * as UploadActions from 'documents-ui/actions/UploadActions';
import { Flex } from 'foundations-components/components/Flex';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import DocumentNotFound from 'documents-ui/components/DocumentNotFound';
import SummaryHeader from 'documents-ui/components/summary/SummaryHeader';
import SummaryRecipientsContainer from './SummaryRecipientsContainer';
import { trackInteraction, trackPermissionSave } from 'documents-lib/js/tracking/tracker';
import { VIEWED_SUMMARY } from 'documents-lib/js/tracking/actions';
import { useFeedbackSurvey } from 'documents-ui/components/hooks/useFeedbackSurvey';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { getDummyDocumentSummary } from 'documents-ui/utils/mockREST';
import { useGetSummaryAnalytics } from '../hooks/useGetSummaryAnalytics';
import AssignmentPanel from 'sales-content-partitioning/panels/AssignmentPanel';
import { getScopes } from 'documents-ui/lib/permissions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryContainer = ({
  match,
  documentsSummary,
  deckVisitors,
  documentsRevisits,
  documentVisitorSearchQuery,
  hasMore,
  visitorsIsLoading,
  visitorsFetchFailure,
  documentsSummaryError,
  reuploadProgressPercent,
  fetchDocumentMetadata,
  fetchDocumentGDPRSetting,
  fetchDocumentVisitors,
  fetchDocumentRevisits,
  removeDocument,
  updateDocument,
  downloadDocument,
  updateDocumentGDPRSetting,
  uploadFile,
  importFile
}) => {
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    deckId: deckIdString
  } = match.params;
  const documentId = Number(deckIdString);
  const {
    loading: documentAnalyticsSummaryLoading,
    error: documentAnalyticsSummaryError
  } = useGetSummaryAnalytics({
    documentId
  });
  useEffect(() => {
    trackInteraction(VIEWED_SUMMARY);
    if (!documentsSummary.has(documentId) && !isUngatedToChirp) {
      fetchDocumentMetadata(documentId);
      fetchDocumentGDPRSetting(documentId);
    }
    if (!isUngatedToChirp) {
      fetchDocumentVisitors({
        deckId: documentId,
        initial: true
      });
    }
    // These actions should only be fired on mount or when the documentId changes
  }, [documentId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Render CSAT survey
  useFeedbackSurvey();
  const handlePercentProgress = percent => {
    reuploadProgressPercent({
      id: documentId,
      percent
    });
  };
  const showErrorState = isUngatedToChirp ? documentAnalyticsSummaryError : documentsSummaryError;
  if (showErrorState) {
    return /*#__PURE__*/_jsx(DocumentNotFound, {});
  }
  const documentSummary = isUngatedToChirp ? getDummyDocumentSummary(documentId) : documentsSummary === null || documentsSummary === void 0 ? void 0 : documentsSummary.get(documentId);
  const isRESTDocumentSummaryLoading = !documentSummary || !documentSummary.metadata || !documentSummary.gdpr;
  const isLoading = isUngatedToChirp ? documentAnalyticsSummaryLoading : isRESTDocumentSummaryLoading;
  if (isLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: 200,
        layout: "centered"
      })
    });
  }
  const {
    metadata,
    gdpr
  } = documentSummary;
  return /*#__PURE__*/_jsxs(ListingPage, {
    headerComponent: /*#__PURE__*/_jsx(SummaryHeader, {
      documentId: documentId,
      documentMetadata: metadata,
      gdprSettings: gdpr,
      updateDocument: updateDocument,
      onPercentProgress: handlePercentProgress,
      removeDocument: removeDocument,
      downloadDocument: downloadDocument,
      uploadFile: uploadFile,
      importFile: importFile,
      updateDocumentGDPRSetting: updateDocumentGDPRSetting
    }),
    children: [/*#__PURE__*/_jsx(AssignmentPanel, {
      scopes: List(getScopes()),
      afterSave: trackPermissionSave
    }), /*#__PURE__*/_jsx(SummaryRecipientsContainer, {
      deckId: documentId,
      title: metadata.get('title') || '',
      gdprSettings: gdpr,
      deckVisitors: deckVisitors,
      documentsRevisits: documentsRevisits,
      documentVisitorSearchQuery: documentVisitorSearchQuery,
      hasMore: hasMore,
      allDocumentSlides: metadata.get('slides'),
      visitorsIsLoading: visitorsIsLoading,
      visitorsFetchFailure: visitorsFetchFailure,
      fetchDocumentVisitors: fetchDocumentVisitors,
      fetchDocumentRevisits: fetchDocumentRevisits
    })]
  });
};
export default connect(({
  documentsSummary
}) => ({
  documentsSummary: documentsSummary.documentsSummary,
  deckVisitors: documentsSummary.deckVisitors,
  documentsRevisits: documentsSummary.documentsRevisits,
  documentVisitorSearchQuery: documentsSummary.documentVisitorSearchQuery,
  hasMore: documentsSummary.hasMore,
  nextOffset: documentsSummary.nextOffset,
  visitorsIsLoading: documentsSummary.visitorsIsLoading,
  visitorsFetchFailure: documentsSummary.visitorsFetchFailure,
  documentsSummaryError: documentsSummary.documentsSummaryError
}), Object.assign({}, DocumentsActions, DocumentsSettingActions, DocumentsSummaryActions, UploadActions))(SummaryContainer);